import {
  APP_ERROR,
  APP_MODAL_ERROR,
  CLOSE_ERROR,
  CLOSE_MODAL_ERROR,
  FILE_UPLOAD_COMPLETED,
  FILE_UPLOAD_STARTED,
  REQUEST_COMPLETED,
  REQUEST_STARTED,
  SET_SIDE_MENU,
  SET_TOP_MENU,
  UPLOAD_LOGO_RESPONSE,
} from "../constants";

export const initialState = {
  loading: false,
  error: undefined,
  modal_error: undefined,
  topMenu: "Home",
  sideMenu: undefined,
  fileUploading: false,
  fileUploadResponse: undefined,
};
export const AppReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case REQUEST_STARTED:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case REQUEST_COMPLETED:
      return {
        ...state,
        loading: false,
      };

    case FILE_UPLOAD_STARTED:
      return {
        ...state,
        fileUploading: true,
        error: undefined,
      };
    case UPLOAD_LOGO_RESPONSE:
      return {
        ...state,
        fileUploadResponse: action.payload,
      };
    case FILE_UPLOAD_COMPLETED:
      return {
        ...state,
        fileUploading: false,
      };

    case APP_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case APP_MODAL_ERROR:
      return {
        ...state,
        modal_error: action.payload,
        loading: false,
      };

    case CLOSE_ERROR:
      return {
        ...state,
        error: undefined,
      };

    case CLOSE_MODAL_ERROR:
      return {
        ...state,
        modal_error: undefined,
      };
    case SET_TOP_MENU:
      return {
        ...state,
        topMenu: action.payload,
      };
    case SET_SIDE_MENU:
      return {
        ...state,
        sideMenu: action.payload,
      };
    default:
      return state;
  }
};
